import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RequiredField } from '../../../app/types/utility';
import { Address, AddressComponent } from '../address/address.component';
import { ContactDetails, ContactDetailsComponent } from '../contact-details/contact-details.component';

import { ContactComponent as KBContactComponent } from '@knorr-bremse-portals/ngx-components/components/contact';


export interface LocationContact extends ContactDetails {
  type: 'location';
  location: Address;
}

interface PersonOrDepartmentContact extends ContactDetails {
  type: 'person' | 'department';
  email: string;
  location?: Address;
  name: string;
}

export interface PersonContact extends PersonOrDepartmentContact {
  type: 'person';
  position: string;
}

export interface PersonContactWithImage extends PersonContact {
  image: string;
}

export interface DepartmentContact extends PersonOrDepartmentContact {
  type: 'department';
}

export type Contact = LocationContact | PersonContact | PersonContactWithImage | DepartmentContact;

@Component({
    selector: 'app-contact',
    imports: [
        KBContactComponent,
        AddressComponent,
        ContactDetailsComponent,
    ],
    templateUrl: './contact.component.html',
    styleUrls: ['./contact.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactComponent {

  @Input() public contact!: Contact;
  @Input() public type!: 'bar' | 'floating';
  @Input() public showImage = true;

  protected getName(contact: Contact): string {
    if (contact.type === 'location') {
      return contact.location.nameLatin ?? '';
    }

     // person & department
    return contact.name;
  }

  protected getSubline(contact: Contact): string {
    if (contact.type === 'location') {
      return contact.location.name ?? '';
    }

    if (contact.type === 'person') {
      return contact.position;
    }

    // department
    return contact.location?.nameLatin ?? '';
  }

  protected isPersonContactWithImage(contact: PersonContact): contact is PersonContactWithImage {
    return (contact as PersonContactWithImage).image !== undefined;
  }

  protected getAddress(contact: RequiredField<Contact, 'location'>): Address {
    const address: Address = {
      ...contact.location,
    };
    if (contact.type === 'location' || contact.type === 'department') {
      address.nameLatin = undefined;
    }
    if (contact.type === 'location') {
      address.name = undefined;
    }
    return address;
  }

  protected isContactWithLocation(contact: Contact): contact is RequiredField<Contact, 'location'> {
    return contact.location !== undefined;
  }

}
